import { type ConsentViewDTO } from '@/types/consumer-deposit-application-service';

import { type InitialApplication } from './useApplication';

export type ConsentsFields = {
  consents: ConsentViewDTO[];
  saveConsents: (consents: ConsentViewDTO[]) => Promise<void>;
};
export const consents = ({
  application,
  save,
}: InitialApplication): ConsentsFields => {
  const consents = application.consents || [];

  const saveConsents = async (nextConsents: ConsentViewDTO[]) => {
    return save({ consents: nextConsents }, { skipLoading: true });
  };

  return {
    consents,
    saveConsents,
  };
};
